<template>
  <input
    v-model="model"
    :placeholder="filter.placeholder"
    class="form-control form-control-sm"
    type="text"
  >
</template>
<script lang="ts" setup>
import type {GridFilter} from './types'

const model = defineModel<string>({required: true})

defineProps({
  filter: {type: Object as () => GridFilter, required: true}
})

</script>
